<template>
  <v-row class="flex-column justify-center align-center">
    <v-col cols="12" sm="12" md="12">
      <v-row class="flex-row justify-center align-center">
        <v-col cols="12" sm="12" md="2" class="calendar-col" style="min-width: 300px">
          <div class="mx-auto" style="max-width: 400px">
            <v-date-picker
              v-model="dates"
              range
              offset-y
              full-width
              no-title
              dark
              reactive
              elevation="16"
              :locale="locale"
              :min="new Date().toISOString()"
            ></v-date-picker>
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="12"
          md="7"
          class="d-flex flex-row datetimes-col pl-4 pb-6 pr-0"
          :style="datetimeColStyleCont"
        >
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="d-flex flex-row datetimes-col pr-0"
            :style="datetimeColStyle"
          >
            <v-row
              v-for="(date, i) in dates"
              :key="i"
              class="d-flex flex-row align-center px-5 align-self-stretch mt-0 mr-0 ml-0 pl-0"
              :class="[
                newCampaign.campaign_type_system !== 'multiple_times_execution' && 'justify-center',
                (i && 'pl-0') || 'pr-0',
              ]"
            >
              <v-col cols="12" class="d-flex flex-column align-center px-5 pt-0 px-8 pl-0 pr-0">
                <v-col
                  cols="12"
                  md="12"
                  class="pb-0 border-top mt-8 pr-0 pl-3"
                  :class="[(i && 'border-right rounded-tr-lg') || 'border-left rounded-tl-lg']"
                  style="min-height: 45px"
                  ><span v-if="i == 0" class="text-h6 ml-auto">{{
                    translations.days[lang]
                  }}</span></v-col
                >

                <v-col
                  class="d-flex flex-row justify-center align-center px-5 pt-0 border-bottom pr-0 pl-2"
                  :class="[(i && 'border-right rounded-br-lg') || 'border-left rounded-bl-lg']"
                  ><span class="text-subtitle-1 font-weight-medium" :class="!i && 'ml-auto'">{{
                    translations[i == 0 ? 'from' : 'to'][lang]
                  }}</span>
                  <v-dialog
                    transition="dialog-bottom-transition"
                    ref="dateDialogs"
                    v-model="dateDialogIsOpen[i]"
                    :return-value.sync="date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        style="max-width: 350px"
                        class="px-3 pt-0 justify-center pr-2"
                        :class="i && 'mr-auto'"
                        v-model="localizedDates[i]"
                        label=""
                        hide-details
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :value="localizeDate(date)"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates[i]"
                      scrollable
                      reactive
                      :locale="locale"
                      :min="new Date().toISOString()"
                      dark
                    >
                      <v-spacer></v-spacer>
                      <v-btn text @click="$set(dateDialogIsOpen, i, false)">
                        {{ translations.cancel[lang] }}
                      </v-btn>
                      <v-btn text @click="$refs.dateDialogs[i].save(date)"> OK </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                  class="pb-0 mt-8 border-top"
                  :class="[(i && 'border-right rounded-tr-lg') || 'border-left rounded-tl-lg']"
                  style="min-height: 45px"
                  ><span v-if="i == 0" class="text-h6 ml-auto">{{
                    translations.hours[lang]
                  }}</span></v-col
                >

                <v-col
                  class="d-flex flex-row justify-center align-center px-5 pt-0 border-bottom"
                  :class="[(i && 'border-right rounded-br-lg') || 'border-left rounded-bl-lg']"
                  ><span class="text-subtitle-1 font-weight-medium" :class="!i && 'ml-auto'">{{
                    translations[i == 0 ? 'from' : 'to'][lang]
                  }}</span>
                  <v-dialog
                    transition="fab-transition"
                    ref="timeDialog"
                    v-model="timeDialogIsOpen[i]"
                    :return-value.sync="dateTimes[i].time"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="px-3 pt-0 px-5 justify-center"
                        :class="i && 'mr-auto'"
                        style="max-width: 150px"
                        v-model="dateTimes[i].time"
                        label=""
                        prepend-icon="mdi-clock-time-four-outline"
                        hide-details
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>

                    <v-time-picker
                      v-if="timeDialogIsOpen[i]"
                      reactive
                      v-model="dateTimes[i].time"
                      full-width
                      dark
                      :min="i ? timeMin : '00:00'"
                      :max="!i ? timeMax : '23:59'"
                      class="campaign-timepicker"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text @click="cancelTimeDialog(i)">
                        {{ translations.cancel[lang] }}
                      </v-btn>
                      <v-btn text @click="saveTimeDialog(i)"> OK </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-col>
            </v-row>
          </v-col>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
      class="d-flex flex-column"
      :class="[dateTimes.length != 2 && 'invisible']"
      style="max-width: 700px"
    >
      <div v-if="selectedOptions.transaction_type_ids !== undefined">
        <div v-if="newCampaign.campaign_type_system === 'new_transaction'" class="mb-3">
          <v-row>
            <v-col cols="12" md="12" class="d-flex justify-center pa-5 pb-2"
              ><span class="text-center text-h6 font-weight-medium">{{
                translations.selectTransactionCategory[lang]
              }}</span></v-col
            ></v-row
          >
          <v-row class="d-flex justify-center transition-all mw-100 py-5 mt-n2">
            <v-btn-toggle v-model="selectedActionType">
              <v-btn
                v-for="(category, index) in transactionActionTypes"
                :key="index"
                :value="category"
                :dark="category == selectedActionType"
                x-large
                min-width="150"
                min-height="60"
              >
                <span
                  :style="{
                    color: category == selectedActionType ? 'white !important' : 'black',
                  }"
                  v-if="translations[`${category}TransactionCategory`]"
                >
                  {{ translations[`${category}TransactionCategory`][lang] }}</span
                >
              </v-btn>
            </v-btn-toggle>
          </v-row>
        </div>
        <v-row>
          <v-col cols="12" md="12" class="d-flex justify-center pa-5"
            ><span class="text-center text-h5">{{
              translations.transactionTypes[lang]
            }}</span></v-col
          ></v-row
        >

        <v-window v-model="selectedActionType" style="min-height: 210px">
          <v-window-item value="register" class="py-4">
            <v-row class="d-flex justify-center transition-all mw-100">
              <v-col
                v-for="(item, index) in registerTransactionTypes"
                :key="index"
                cols="12"
                sm="12"
                md="2"
                class="d-flex flex-column justify-center align-center ma-2 mt-0 pa-2 pt-2 pb-0 select-transaction-type transition-all text-subtitle-2 rounded-lg text-center"
                :class="[
                  selectedOptions.transaction_type_ids.includes(item.transaction_type_id) &&
                    'selected-condition',
                ]"
                @click="selectTransactionType(item)"
              >
                <v-sheet
                  class="rounded-circle pa-1 text-center pr-0 pl-0 mw-100 text-subtitle-2 border-grey"
                >
                  <v-icon
                    class="ma-3 text-subtitle-1"
                    size="70"
                    v-text="transactionTypesIcons[item.transaction_type_id]"
                  ></v-icon>
                </v-sheet>
                <div
                  class="text-center pr-0 pl-0 mw-100 text-body-2 d-flex align-center"
                  style="min-height: 75px"
                >
                  {{ item.translation || item.name }}
                </div>
              </v-col>
            </v-row>
          </v-window-item>
          <v-window-item value="order" class="py-4">
            <v-row class="d-flex justify-center transition-all mw-100">
              <v-col
                v-for="(item, index) in orderTransactionTypes"
                :key="index"
                cols="12"
                sm="12"
                md="2"
                class="d-flex flex-column justify-center align-center ma-2 mt-0 pa-2 pt-2 pb-0 select-transaction-type transition-all text-subtitle-2 rounded-lg text-center"
                :class="[
                  selectedOptions.transaction_type_ids.includes(item.transaction_type_id) &&
                    'selected-condition',
                ]"
                @click="selectTransactionType(item)"
              >
                <v-sheet
                  class="rounded-circle pa-1 text-center pr-0 pl-0 mw-100 text-subtitle-2 border-grey"
                >
                  <v-icon
                    class="ma-3 text-subtitle-1"
                    size="70"
                    v-text="transactionTypesIcons[item.transaction_type_id]"
                  ></v-icon>
                </v-sheet>
                <div
                  class="text-center pr-0 pl-0 mw-100 text-body-2 d-flex align-center"
                  style="min-height: 75px"
                >
                  {{ item.name }}
                </div>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </div>
      <v-window v-model="selectedActionType" style="min-height: 250px" vertical reverse>
        <v-window-item value="register"> </v-window-item>

        <v-window-item value="order">
          <div v-if="selectedOptions.store_ids !== undefined">
            <v-autocomplete
              prepend-inner-icon="mdi-store"
              :items="storesData"
              v-model="selectedStores"
              item-text="name"
              item-value="store_id"
              menu-props="offsetY"
              :label="translations.stores[lang]"
              class="mt-4"
              outlined
              clearable
              dense
              hide-details
              multiple
              :search-input.sync="searchStores"
              :loading="loading"
              :disable-lookup="true"
              item-disabled="disable"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-if="selectedStores.length < 5"
                  v-bind="data.attrs"
                  small
                  close
                  class="mt-1"
                  @click:close="removeSelectedStore(data)"
                >
                  {{ data.item.name }}
                </v-chip>
                <div v-else-if="data.index === 0">
                  {{
                    (allStoresAreSelected && translations.all[lang]) ||
                    `${selectedStores.length} ` + translations.storesSelected[lang]
                  }}
                </div>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple style="cursor: pointer" @click="toggleSelectAllStores">
                  <v-checkbox
                    @click.stop.prevent="toggleSelectAllStores"
                    v-model="allStoresAreSelected"
                    readonly
                    class="ml-0 mt-0 mb-n3 transition-all"
                    color="secondary"
                  >
                  </v-checkbox>
                  <v-list-item-action class="ml-6">
                    {{ translations.all[lang] }}
                  </v-list-item-action>
                </v-list-item>
              </template>

              <template v-slot:append-item>
                <div v-intersect="endIntersectStores"></div>
                <v-list-item v-if="loading">
                  <v-list-item-action class="ml-1">
                    <v-row class="d-flex align-center">
                      <v-btn
                        class="text-capitalize"
                        depressed
                        fab
                        small
                        :loading="true"
                        style="background: transparent"
                      >
                      </v-btn>
                      <span class="pa-2">{{ translations.loadMore[lang] }}</span>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-autocomplete>
          </div>
          <div v-if="selectedOptions.goal !== undefined" class="d-flex flex-row align-end">
            <v-select
              v-if="selectedOptions.goal !== undefined"
              prepend-inner-icon="mdi-bullseye"
              :items="goalTypes"
              item-text="name"
              item-value="value"
              v-model="selectedOptions.goal.type"
              menu-props="offsetY"
              :label="translations.goalTypes[lang]"
              class="pr-1"
              outlined
              dense
              hide-details
            >
            </v-select>
            <b-text-field
              :label="translations[(selectedOptions.goal.type || '') + '_number'][lang]"
              v-model="selectedOptions.goal.counter"
              type="number"
              class="pl-1"
            ></b-text-field>
          </div>

          <div v-if="selectedOptions.product_purchased_ids !== undefined">
            <v-autocomplete
              v-if="Array.isArray(selectedOptions.product_purchased_ids['1'])"
              v-model="selectedOptions.product_purchased_ids['1']"
              :items="[...this.selectedProductsData['1'], ...products1x]"
              :item-text="'name[' + lang + ']'"
              item-value="product_id"
              menu-props="offsetY"
              :label="translations.purchasedProducts[lang] + translations.singleParticipation[lang]"
              class="mt-4"
              outlined
              prepend-inner-icon="mdi-package-variant-closed"
              dense
              hide-details
              multiple
              chips
              small-chips
              deletable-chips
              :search-input.sync="searchProducts1x"
              :loading="loading"
              @blur="
                () => {
                  searchProducts1x = '';
                  searchProducts = '';
                }
              "
            >
              <template v-slot:append-item v-if="productsTotalPages > productsPage">
                <div v-intersect="endIntersectProducts"></div>
                <v-list-item ripple @click="loadMoreProducts()">
                  <v-list-item-action class="ml-14">
                    {{ translations.loadMore[lang] }}
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-autocomplete>

            <v-autocomplete
              v-if="Array.isArray(selectedOptions.product_purchased_ids['2'])"
              v-model="selectedOptions.product_purchased_ids['2']"
              :items="[...this.selectedProductsData['2'], ...products2x]"
              :item-text="'name[' + lang + ']'"
              item-value="product_id"
              menu-props="offsetY"
              :label="translations.purchasedProducts[lang] + translations.doublePraticipation[lang]"
              class="mt-4"
              outlined
              prepend-inner-icon="mdi-package-variant-closed"
              dense
              hide-details
              multiple
              chips
              small-chips
              deletable-chips
              :search-input.sync="searchProducts2x"
              :loading="loading"
              @blur="
                () => {
                  searchProducts2x = '';
                  searchProducts = '';
                }
              "
            >
              <template v-slot:append-item v-if="productsTotalPages > productsPage">
                <div v-intersect="endIntersectProducts"></div>
                <v-list-item ripple @click="loadMoreProducts()">
                  <v-list-item-action class="ml-14">
                    {{ translations.loadMore[lang] }}
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-autocomplete>
            <v-autocomplete
              v-if="Array.isArray(selectedOptions.product_purchased_ids)"
              v-model="selectedOptions.product_purchased_ids"
              :items="[...selectedProductsData['0'], ...products]"
              :item-text="'name[' + lang + ']'"
              item-value="product_id"
              menu-props="offsetY"
              :label="translations.purchasedProducts[lang]"
              class="mt-4"
              outlined
              prepend-inner-icon="mdi-package-variant-closed"
              dense
              hide-details
              multiple
              :search-input.sync="searchProducts"
              :loading="loading"
            >
              <template v-slot:append-item v-if="productsTotalPages > productsPage">
                <div v-intersect="endIntersectProducts"></div>
                <v-list-item ripple @click="loadMoreProducts()">
                  <v-list-item-action class="ml-14">
                    {{ translations.loadMore[lang] }}
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-autocomplete>
          </div>
          <div class="d-flex flex-row">
            <b-text-field
              v-if="selectedOptions.at_least_currency_spent !== undefined"
              :label="translations.minAmmount[lang]"
              v-model="selectedOptions.at_least_currency_spent"
              type="number"
              class="pr-1"
            ></b-text-field>

            <b-text-field
              v-if="selectedOptions.product_purchased_min_quantity !== undefined"
              :label="translations.minQuantity[lang]"
              v-model="selectedOptions.product_purchased_min_quantity"
              type="number"
              class="pl-1"
            ></b-text-field>

            <b-text-field
              v-if="selectedOptions.at_least_points_won !== undefined"
              :label="translations[`min_${storeMode}`][lang]"
              v-model="selectedOptions.at_least_points_won"
              type="number"
            ></b-text-field>

            <b-text-field
              v-if="selectedOptions.minimum_transactions !== undefined"
              v-model="selectedOptions.minimum_transactions"
              :label="translations.minimum_transctions[lang]"
              type="number"
              class="pl-1"
            ></b-text-field>
          </div>

          <v-checkbox
            v-if="selectedOptions.price_to_product !== undefined"
            color="secondary"
            class="mt-3 pt-0"
            hide-details
            v-model="selectedOptions.price_to_product"
          >
            <template v-slot:label>
              <h4 class="subtitle-2">
                {{ translations.minAmountRule[lang] }}
              </h4>
            </template>
          </v-checkbox>

          <div class="d-flex flex-row">
            <b-text-field
              v-if="selectedOptions.maximum_number_of_entries_per_participant !== undefined"
              v-model="selectedOptions.maximum_number_of_entries_per_participant"
              :label="translations.maximumEntriesPerParticipant[lang]"
              type="number"
              class="pr-1"
            ></b-text-field>

            <b-text-field
              v-if="selectedOptions.execute_after_mins !== undefined"
              v-model="selectedOptions.execute_after_mins"
              :label="translations.executeAfterMinutes[lang]"
              type="number"
              class="pl-1"
            ></b-text-field>

            <b-text-field
              v-if="selectedOptions.execute_after_goal_completed_mins !== undefined"
              v-model="selectedOptions.execute_after_goal_completed_mins"
              :label="translations.executeAfterGoalMinutes[lang]"
              type="number"
              class="pl-1"
            ></b-text-field>
          </div>
        </v-window-item>
      </v-window>
    </v-col>
  </v-row>
</template>

<script>
import {
  mdiArrowLeft,
  mdiArrowRight,
  mdiCalendarMonth,
  mdiClockOutline,
  mdiCellphoneSound,
  mdiPrinterPos,
  mdiStore,
  mdiAndroid,
  mdiApi,
  mdiClipboardAccountOutline,
  mdiBadgeAccountOutline,
} from '@mdi/js';
import { mapMutations, mapState, mapActions } from 'vuex';
import moment from 'moment';
import debounce from 'lodash/debounce';
import translations from '@/utils/translations/loyaltyPanel/campaigns/newCampaign';
import newCampaign from '../../../store/modules/loyaltyPanel/campaigns/newCampaign';
import { cloneDeep } from 'lodash';

export default {
  name: 'Step2Action',

  mixins: [translations],

  data: () => ({
    icons: {
      mdiArrowLeft,
      mdiArrowRight,
      mdiCalendarMonth,
      mdiClockOutline,
    },

    transactionTypesIcons: {
      4: mdiCellphoneSound,
      5: mdiPrinterPos,
      10: mdiStore,
      11: mdiAndroid,
      17: mdiApi,
      2: mdiClipboardAccountOutline,
      3: mdiBadgeAccountOutline,
    },
    deleteOnCancel: false,
    startTime: new Date().getHours() + ':' + new Date().getMinutes(),
    timeDialogIsOpen: [],
    dateDialogIsOpen: [],
    dates: [],
    dateTimes: [],
    selectedStores: [],
    selectedStoresData: [],
    selectedProductsData: {
      0: [],
      1: [],
      2: [],
    },
    searchProducts: '',
    searchProducts1x: '',
    searchProducts2x: '',
    searchStores: '',
    allStoresAreSelected: false,
    productsPage: 1,
    pageStores: 1,
    options: {
      start_date: '',
      from_hour: '',
      end_date: '',
      to_hour: '',
      transaction_type_ids: [],
      at_least_currency_spent: '1',
      execute_after_mins: '30',
      maximum_number_of_entries_per_participant: null,
    },
    selectedActionType: 'order',
  }),

  computed: {
    ...mapState(['loading', 'serverItemsLength']),
    ...mapState('loyaltyPanel/campaigns/newCampaign', [
      'canGoToNextStep',
      'products',
      'productsPagination',
      'transactionTypes',
      'storesPagination',
      'stores',
      'step',
      'campaignTypes',
    ]),

    lang() {
      return this.$route.params.lang;
    },
    locale() {
      if (this.lang == 'el') return 'el-GR';
      if (this.lang == 'it') return 'it-IT';
      return 'en-GB';
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    productsTotalPages() {
      return this.productsPagination.total_pages;
    },
    queryStores() {
      return this.searchStores
        ? `?q=${this.searchStores}&page=${this.pageStores}`
        : `?page=${this.pageStores}`;
    },
    goalTypes() {
      return [
        {
          name: this.translations.transactions[this.lang],
          value: 'transactions',
        },
        {
          name: this.translations[`total_${this.storeMode}`][this.lang],
          value: 'total_points',
        },
        {
          name: this.translations.total_price[this.lang],
          value: 'total_price',
        },
        {
          name: this.translations.total_litres[this.lang],
          value: 'total_litres}',
        },
      ];
    },
    datetimeColStyle() {
      if (this.dateTimes.length == 2) return { 'max-width': '850px', opacity: '1', padding: 0 };
      return {
        'max-width': '0px',
        opacity: '0',
        padding: 0,
        overflow: 'hidden',
      };
    },
    datetimeColStyleCont() {
      if (this.dateTimes.length == 2)
        return {
          'max-width': '850px',
          'min-width': '700px',
          opacity: '1',
          padding: 0,
        };
      return {
        'max-width': '0px',
        'min-width': '0px',
        opacity: '0',
        padding: 0,
        overflow: 'hidden',
      };
    },
    localizedDates() {
      return this.dates.map((date) => this.localizeDate(date));
    },

    newCampaign: {
      get() {
        return this.$store.state.loyaltyPanel.campaigns.newCampaign.newCampaign;
      },
      set(val) {
        this.setNewCampaign(val);
      },
    },

    productsQuery() {
      if (this.searchProducts) {
        return `?q=${this.searchProducts}&page=${this.productsPage}`;
      }

      return `?page=${this.productsPage}`;
    },
    selectedCampaignType() {
      return (this.campaignTypes?.[this.newCampaign.category]?.campaign_types || []).find(
        (x) => x.campaign_type_id == this.newCampaign.campaign_type_id
      );
    },
    selectedOptions() {
      return this.selectedCampaignType?.options || this.options;
    },
    timeMin() {
      return this.dateTimes[0]?.time || '00:00';
    },
    timeMax() {
      return this.dateTimes[1]?.time || '23:59';
    },
    products1x() {
      return this.products.filter(
        (e) => !(this.selectedOptions.product_purchased_ids?.['2'] || []).includes(e.product_id)
      );
    },
    products2x() {
      return this.products.filter((e) => {
        return !(this.selectedOptions.product_purchased_ids?.['1'] || []).includes(e.product_id);
      });
    },
    storesData() {
      return [...this.stores, ...this.selectedStoresData].map((e) => ({
        ...e,
        disable: this.allStoresAreSelected,
      }));
    },

    orderTransactionTypes() {
      return this.transactionTypes?.filter((t) => t.type == 'order');
    },

    registerTransactionTypes() {
      let items = this.transactionTypes?.filter((t) => t.type == 'register');
      return items.map((item) => {
        let registrationType = item.name.split(' ')[0].toLowerCase();
        let translation =
          this.translations[`${registrationType}_registration_${this.storeMode}`]?.[this.lang];
        return translation
          ? {
              ...item,
              translation,
            }
          : item;
      });
    },
    transactionActionTypes() {
      return this.transactionTypes.reduce((a, c) => {
        if (!a.includes(c.type)) {
          a.push(c.type);
        }
        return a;
      }, []);
    },
  },

  methods: {
    ...mapMutations('loyaltyPanel/campaigns/newCampaign', ['setNewCampaign', 'setCanGoToNextStep']),

    ...mapActions('loyaltyPanel/campaigns/newCampaign', [
      'getProducts',
      'getTransactionTypes',
      'getStores',
      'getCampaignTypes',
    ]),
    handleSearchStores() {
      const body = {
        query: this.queryStores,
        page: this.pageStores,
      };
      this.getStores(body);
    },
    endIntersectProducts(entries, observer, isIntersecting) {
      if (isIntersecting && this.products && this.products.length < this.productsPagination.total) {
        this.loadMoreProducts();
      }
    },
    async loadMoreStores() {
      this.pageStores++;
      const body = {
        query: this.queryStores,
        page: this.pageStores,
      };
      await this.getStores(body);
      if (this.allStoresAreSelected) {
        this.stores.map((item) => {
          if (!this.selectedStores.includes(item.store_id)) {
            this.selectedStores.push(item.store_id);
          }
        });
      }
    },

    endIntersectStores(entries, observer, isIntersecting) {
      if (isIntersecting && this.stores && this.stores.length < this.storesPagination.total) {
        this.loadMoreStores();
      }
    },

    toggleSelectAllStores() {
      if (this.allStoresAreSelected) {
        this.allStoresAreSelected = false;
        this.selectedStores.map((item, index) => {
          this.selectedStores.splice(index, this.selectedStores.length);
        });
        this.selectedOptions.store_participants = '';
      } else {
        this.allStoresAreSelected = true;
        this.stores.map((item) => {
          if (!this.selectedStores.includes(item.store_id)) {
            this.selectedStores.push(item.store_id);
          }
        });
        this.selectedOptions.store_participants = '*';
      }
    },

    chooseTime(i, cancelDelete = false) {
      this.deleteOnCancel = cancelDelete;
      if (this.newCampaign.campaign_type_system !== 'multiple_times_execution') {
        while (i > 0) {
          this.dates.shift();
          i--;
        }
      }
      if (this.dateTimes[i]) {
        this.$set(this.timeDialogIsOpen, i, true);
      }
    },

    localizeDate(date) {
      return new Date(date).toLocaleString(this.locale, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },

    deleteDate(i) {
      this.dates.splice(i, 1);
      this.deleteOnCancel = false;
    },

    saveTimeDialog(i) {
      this.$refs.timeDialog[i].save(this.dateTimes[i].time);
      this.$set(this.timeDialogIsOpen, i, false);
      this.deleteOnCancel = false;
    },

    cancelTimeDialog(i) {
      this.$set(this.timeDialogIsOpen, i, false);
      if (this.deleteOnCancel) this.deleteDate(i);
    },

    goToNextStep() {
      this.$emit('next');
    },

    loadMoreProducts() {
      this.productsPage++;
      const body = {
        query: this.productsQuery,
        page: this.productsPage,
      };
      this.getProducts(body);
    },

    handleSearchProducts() {
      const body = {
        query: this.productsQuery,
        page: this.productsPage,
      };
      this.getProducts(body);
    },

    selectTransactionType(val, array) {
      this.selectedOptions.transaction_type_ids = this.selectedOptions.transaction_type_ids || [];
      let ids = this.selectedOptions.transaction_type_ids;
      let typeIndex = ids.findIndex((x) => x == val.transaction_type_id);
      if (typeIndex >= 0) {
        ids.splice(typeIndex, 1);
      } else {
        ids.push(val.transaction_type_id);
      }
    },
    checkStepValidity() {
      let opt = this.newCampaign.campaign_type_id_options;

      if (
        !opt.transaction_type_ids?.length ||
        !opt.start_date ||
        !opt.end_date ||
        !opt.from_hour ||
        !opt.to_hour ||
        !(/^\d+$/.test(opt.at_least_currency_spent) && Number(opt.at_least_currency_spent) >= 1)
      ) {
        return false;
      }
      if (this.selectedActionType == 'register') {
        return true;
      }
      if (opt.execute_after_mins !== undefined) {
        if (!(/^\d+$/.test(opt.execute_after_mins) && Number(opt.execute_after_mins) >= 0)) {
          return false;
        }
      }

      if (opt.execute_after_goal_completed_mins !== undefined) {
        if (
          !(
            /^\d+$/.test(opt.execute_after_goal_completed_mins) &&
            Number(opt.execute_after_goal_completed_mins) >= 0
          )
        ) {
          return false;
        }
      }

      if (opt.minimum_transactions !== undefined) {
        if (!(/^\d+$/.test(opt.minimum_transactions) && Number(opt.minimum_transactions) > 0)) {
          return false;
        }
      }

      if (opt.product_purchased_min_quantity !== undefined) {
        if (
          !(
            /^\d+$/.test(opt.product_purchased_min_quantity) &&
            Number(opt.product_purchased_min_quantity) > 0
          ) ||
          (!opt.product_purchased_ids?.['1']?.length && !opt.product_purchased_ids?.['2']?.length)
        ) {
          return false;
        }
      }

      if (opt.at_least_points_won !== undefined) {
        if (!(/^\d+$/.test(opt.at_least_points_won) && Number(opt.at_least_points_won) >= 1)) {
          return false;
        }
      }
      if (opt.store_ids !== undefined) {
        if (!opt.store_ids.length && !this.allStoresAreSelected) {
          return false;
        }
      }

      return true;
    },

    formDateTimes(val) {
      this.dateTimes = val.reduce((a, c, i) => {
        let dateTime = this.dateTimes.find((x) => x.date == c);
        if (!dateTime || !dateTime.date) {
          return [
            ...a,
            {
              date: c,
              time: '00:00',
            },
          ];
        }
        return [...a, { ...dateTime }];
      }, []);
      if (
        this.dateTimes.length == 2 &&
        this.dateTimes[0].date < this.dateTimes[1].date &&
        (!this.dateTimes[1].time || this.dateTimes[1].time <= this.dateTimes[0].time)
      ) {
        this.dateTimes[1].time =
          new Date(new Date().setHours(23, 59, 59, 0)).toLocaleTimeString('el-GR', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
          }) + '';
      }
    },
    removeSelectedStore(data) {
      this.selectedStores.splice(data.index, 1);
    },
  },

  watch: {
    searchProducts() {
      this.productsPage = 1;
      this.debouncedSearchProducts();
    },

    searchStores() {
      this.pageStores = 1;
      this.debouncedSearchStores();
    },

    dates: {
      handler(val) {
        if (val[0] > val[1]) {
          this.$set(this, 'dates', [val[1], val[0]]);
        }
        this.formDateTimes(val);
      },
      deep: true,
    },

    dateTimes: {
      handler(val) {
        this.selectedOptions.start_date = val[0]?.date || '';
        this.selectedOptions.from_hour = val[0]?.time || '';
        this.selectedOptions.end_date = val[1]?.date || '';
        this.selectedOptions.to_hour = val[1]?.time || '';
      },
      deep: true,
    },

    selectedOptions: {
      handler(val) {
        if (!val.start_date && this.dateTimes?.[0]?.date) {
          val.start_date = this.dateTimes[0].date;
        }
        if (!val.from_hour && this.dateTimes?.[0]?.time) {
          val.from_hour = this.dateTimes[0].time;
        }
        if (!val.end_date && this.dateTimes?.[1]?.date) {
          val.end_date = this.dateTimes[1].date;
        }
        if (!val.to_hour && this.dateTimes?.[1]?.time) {
          val.to_hour = this.dateTimes[1].time;
        }

        this.$set(this.newCampaign, 'campaign_type_id_options', val);
        this.setCanGoToNextStep(this.checkStepValidity());
      },
      deep: true,
    },

    allStoresAreSelected: {
      handler(val) {
        if (val) {
          this.selectedOptions.store_ids = [];
        }
      },
      deep: true,
    },
    selectedStores: {
      handler(val) {
        // if(this.selectedStores.length != this.storesPagination?.total){
        //     this.allStoresAreSelected = false
        // }
        if (!this.allStoresAreSelected) {
          //     this.selectedOptions.store_ids =  []
          // }else {
          this.selectedOptions.store_ids = val;
          this.selectedStoresData.forEach((storeData, i) => {
            let foundStore = val.find((x) => x == storeData.store_id);
            if (!foundStore) {
              this.selectedStoresData.splice(i, 1);
            }
          });
          val.forEach((id) => {
            let foundId = this.selectedStoresData.find((x) => x?.store_id == id);
            if (!foundId) {
              this.selectedStoresData.push(this.stores.find((x) => x?.store_id == id));
            }
          });
        }
      },
      deep: true,
    },
    ['selectedOptions.product_purchased_ids']: {
      handler(val) {
        let absents = {
          0: [],
          1: [],
          2: [],
        };
        if (Array.isArray(this.selectedOptions.product_purchased_ids?.['1'])) {
          this.selectedProductsData['1'].forEach((p) => {
            if (!this.products.find((x) => x.product_id == p.product_id)) {
              absents['1'].push(p);
            }
          });
          this.selectedProductsData['1'] = [...absents['1'], ...this.products].filter((p) =>
            val['1'].includes(p.product_id)
          );
        }
        if (Array.isArray(this.selectedOptions.product_purchased_ids?.['2'])) {
          this.selectedProductsData['2'].forEach((p) => {
            if (!this.products.find((x) => x.product_id == p.product_id)) {
              absents['2'].push(p);
            }
          });
          this.selectedProductsData['2'] = [...absents['2'], ...this.products].filter((p) =>
            val['2'].includes(p.product_id)
          );
        }
        if (Array.isArray(this.selectedOptions.product_purchased_ids)) {
          this.selectedProductsData['0'].forEach((p) => {
            if (!this.products.find((x) => x.product_id == p.product_id)) {
              absents['0'].push(p);
            }
          });
          this.selectedProductsData['0'] = [...absents['0'], ...this.products].filter((p) =>
            val.includes(p.product_id)
          );
        }
      },
      deep: true,
    },
    step: {
      handler(val) {
        if (val == 2 && this.newCampaign.category == 'action') {
          this.setCanGoToNextStep(this.checkStepValidity());
        }
      },
    },

    searchProducts1x: {
      handler(val) {
        if (val) {
          this.searchProducts = val;
        }
      },
    },

    searchProducts2x: {
      handler(val) {
        if (val) {
          this.searchProducts = val;
        }
      },
    },
    selectedActionType: {
      handler(val) {
        if (val) {
          this.selectedOptions.transaction_type_ids = [];
        }
      },
    },

    ['newCampaign.campaign_type_system']: {
      handler(val) {
        if (!val || val != 'new_transaction') {
          this.selectedActionType = 'order';
        }
      },
      immediate: true,
    },
  },

  async mounted() {
    let options = null;
    if (this.newCampaign.campaign_type_id_options) {
      options = cloneDeep(this.newCampaign.campaign_type_id_options);
    }
    if (!this.campaignTypes?.length) {
      await this.getCampaignTypes();
    }
    if (options) {
      if (options.start_date) {
        this.dates.push(options.start_date);
        this.selectedCampaignType.options.start_date = options.start_date;
        if (options.from_hour) {
          this.dateTimes[0] = {
            date: options.start_date,
            time: options.from_hour,
          };
          this.selectedCampaignType.options.from_hour = options.from_hour;
        }
      }

      if (options.end_date) {
        this.dates.push(options.end_date);
        this.selectedCampaignType.options.end_date = options.end_date;

        if (options.to_hour) {
          this.dateTimes[1] = {
            date: options.end_date,
            time: options.to_hour,
          };
          this.selectedCampaignType.options.to_hour = options.to_hour;
        }
      }

      if (options.at_least_currency_spent) {
        this.selectedCampaignType.options.at_least_currency_spent = options.at_least_currency_spent;
      }

      if (options.at_least_points_won) {
        this.selectedCampaignType.options.at_least_points_won = options.at_least_points_won;
      }

      if (options.execute_after_mins) {
        this.selectedCampaignType.options.execute_after_mins = options.execute_after_mins;
      }

      if (options.maximum_number_of_entries_per_participant) {
        this.selectedCampaignType.options.maximum_number_of_entries_per_participant =
          options.maximum_number_of_entries_per_participant;
      }

      if (options.minimum_transactions) {
        this.selectedCampaignType.options.minimum_transactions = options.minimum_transactions;
      }

      if (options.product_purchased_min_quantity) {
        this.selectedCampaignType.options.product_purchased_min_quantity =
          options.product_purchased_min_quantity;
      }

      if (options.price_to_product) {
        this.selectedCampaignType.options.price_to_product = options.price_to_product;
      }

      if (options.transaction_types?.length) {
        this.selectedCampaignType.options.transaction_type_ids = options.transaction_types.map(
          (e) => e.transaction_id
        );
      }

      if (options.stores?.length) {
        options.stores.forEach((store) => {
          if (!this.selectedStoresData.includes(store.store_id)) {
            this.selectedStoresData.push(store);
          }
          this.selectedStores.push(store.store_id);
        });
      }

      if (options.products) {
        if (
          Array.isArray(this.selectedOptions.product_purchased_ids) &&
          Array.isArray(options.products)
        ) {
          options.products.forEach((product) => {
            if (!this.selectedProductsData['0'].includes(product.product_id)) {
              this.selectedProductsData['0'].push(product);
            }
            this.selectedCampaignType.options.product_purchased_ids.push(product.product_id);
          });
        }
        if (
          Array.isArray(this.selectedOptions.product_purchased_ids['1']) &&
          Array.isArray(options.products?.['_1'])
        ) {
          options.products['_1'].forEach((product) => {
            if (!this.selectedProductsData['1'].includes(product.product_id)) {
              this.selectedProductsData['1'].push(product);
            }
            this.selectedCampaignType.options.product_purchased_ids['1'].push(product.product_id);
          });
        }
        if (
          Array.isArray(this.selectedOptions.product_purchased_ids['2']) &&
          Array.isArray(options.products?.['_2'])
        ) {
          options.products['_2'].forEach((product) => {
            if (!this.selectedProductsData['2'].includes(product.product_id)) {
              this.selectedProductsData['2'].push(product);
            }
            this.selectedCampaignType.options.product_purchased_ids['2'].push(product.product_id);
          });
        }
      }

      if (options && options.goal) {
        this.selectedCampaignType.options.goal = {
          counter: options.goal.counter || 1,
          type: options.goal.type || '',
        };
      }
      if (options.execute_after_goal_completed_mins) {
        this.selectedCampaignType.options.execute_after_goal_completed_mins =
          options.execute_after_goal_completed_mins;
      }
    }

    if (!!this.newCampaign.product_purchased_ids !== undefined) {
      this.getProducts({
        query: this.productsQuery,
        page: this.productsPage,
      });
    }
  },

  async created() {
    this.getTransactionTypes();
    this.debouncedSearchStores = debounce(this.handleSearchStores, 500);
    this.debouncedSearchProducts = debounce(this.handleSearchProducts, 500);

    if (this.selectedOptions.transaction_type_ids !== undefined) {
      this.selectedOptions.transaction_type_ids = this.selectedOptions.transaction_type_ids || [];
    }
  },
};
</script>
<style scoped>
.deleteDateTime {
  cursor: pointer;
  padding: 1px 8px 3px 8px;
  margin-bottom: 15px;
  border-radius: 15px;
}
.deleteDateTime:hover {
  font-weight: 550;
  background-color: rgba(0, 0, 0, 0.2);
}
.calendar-col {
  transition: all 0.5s ease-in-out;
}
.datetimes-col {
  transition: all 0.8s ease-in-out;
}
</style>
<style>
.campaign-timepicker .primary--text {
  color: #1bbae1 !important;
}
.campaign-timepicker .v-picker__title__btn--active {
  font-weight: 600 !important;
}
.border-left {
  border-left: 1px solid #1bbae199;
  background-color: #1bbae130;
}
.border-top {
  background-color: #1bbae130;
  border-top: 1px solid #1bbae199;
}
.border-right {
  background-color: #1bbae130;
  border-right: 1px solid #1bbae199;
}
.border-bottom {
  background-color: #1bbae130;
  border-bottom: 1px solid #1bbae199;
}

.border-grey {
  border: 2px solid grey;
}

.b-outlined {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.icon-container {
  /* margin-top:20px; */
  height: 200px;
  width: 200px;
}
.select-transaction-type {
  cursor: pointer;
  transition: all 0.5s ease-out;
  background-color: white;
  min-width: 80px;
  font-size: 22px;
  color: gray;
  /* border: 1px solid black */
}
.select-transaction-type:hover {
  /* background-color: rgba(0, 0, 0, 0.2); */
  background-color: #27272730;
  color: black;
  border-color: black;
  /* font-size: 26px; */
}

.invisible {
  opacity: 0;
  z-index: 0;
}

.overlapped {
  position: absolute;
}

.transition-all {
  transition:
    all 1s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 1s;
}
.back-button {
  position: absolute;
  top: 45%;
  z-index: 10;
}
.mw-100 {
  min-width: 100% !important;
}
.mw-180 {
  min-width: 180px !important;
}
.selected-condition {
  color: white;
  background: #272727;
  border-color: #272727;
}
.selected-condition .v-icon {
  background: white;
  color: #272727;
}
.selected-condition .border-grey {
  border-color: #272727;
}
.v-list-item--disabled {
  opacity: 0.7;
}
</style>
